import { defineMessages } from 'react-intl';

export const THRESHOLD_MESSAGES = defineMessages({
  thresholdLabel: {
    id: 'VXB6h9uDSpOZsvwP',
    defaultMessage: 'Threshold',
    description:
      'Text displayed when hovering the threshold point or pill and no default label has been set',
  },
});
